<template>
	<div class="image-previewer">
		<div
			class="image-preview m-auto"
			:style="{ backgroundImage: `url('${imageUrl}')` }"
			v-tooltip="title"
			@click.stop="showPreview">
		</div>
		<div class="modals">
			<!-- Transfer Receipt Viewer -->
			<modal
				class="coupon-editor-modal"
				size="medium"
				type="lightbox"
				@close="isPreviewVisible = false"
				v-if="isPreviewVisible">
				<div slot="header"><h3>Payment Receipt</h3></div>
				<div slot="body" class="text-center">
					<img class="w-100" :src="imageUrl">
				</div>
				<template slot="footer">
					<button type="button" class="btn btn-light" @click="isPreviewVisible = false">{{ $t('Close') }}</button>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
	name: 'ImagePreview',
	props: {
		imageUrl: {
			type: String,
			default: '',
		},
		title: {
			type: String,
			default: '',
		},
	},
	components: {
		Modal,
	},
	data() {
		return {
			isPreviewVisible: false,
		};
	},
	methods: {
		showPreview() {
			this.isPreviewVisible = true;
		},
	},
};
</script>
